// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { useTranslation } from 'react-i18next';

// Roles: 'admin', 'manager', 'staff', 'accountant'
const ProtectedRoute = ({ allowedRoles }) => {
  const { user, isAuthenticated } = useAuth();
  const { t } = useTranslation();

  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }

  const hasRequiredRole = user && allowedRoles && allowedRoles.includes(user.role);

  if (allowedRoles && !hasRequiredRole) {
     // Optional: Redirect to an unauthorized page or show a message
     console.warn(`User role '${user?.role}' not in allowed roles:`, allowedRoles);
     return (
        <div className="container mt-5">
            <h2>{t('unauthorized')}</h2>
            <p>You do not have permission to access this page.</p>
         </div>
     );
    // return <Navigate to="/unauthorized" replace />; // Or redirect
  }

  // Render the child route if authenticated and authorized
  return <Outlet />;
};

export default ProtectedRoute;